import { InputLabel, Stack, TextField, Typography, useTheme } from "@mui/material";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useState } from "react";
import { Link } from "react-router-dom";
import { AuthFormData } from "src/assets/data";
import { BaseBTN, LoadingScreen, PasswordInput } from "src/components/ui";
import Cookies from "js-cookie";
import SSOIcon from "src/components/ui/svgIcon/SSOIcon";
import loginValidation from "../../utils/validations/loginValidation";
import useSecureLogin from "src/services/login/useSecureLogin";
import ConfirmationDialog from "./ConfirmationDialog";

const LoginForm = () => {
  const theme = useTheme();
  const { userSecureLogin, fetchWSO2Token, loading: loadingSecureLogin } = useSecureLogin();
  const [open, setOpen] = useState([false, ""]);
  const welcomeUrl = process.env.REACT_APP_WELCOME_PAGE_BUTTOM_LINK;

  const handleSubmit = (values) => {
    userSecureLogin(values);
  };

  const handleOpenRegister = () => {
    setOpen([true, "MANUAL"]);
  };

  const handleOpenSSORegister = () => {
    setOpen([true, "SSO"]);
  };

  const handleCloseRegister = () => {
    setOpen([false, open[1]]);
  };

  function loginGoverment() {
    if (process.env.REACT_APP_AUTH === "BOTH" || process.env.REACT_APP_AUTH === "SSO") {
      Cookies.remove("UserChoice");
      Cookies.set("UserChoice", "login");
      window.location.href = process.env.REACT_APP_SSO_URL;
    }
  }

  const [formData, setFormData] = useState({ username: "", password: "" });

  function popUpTracking() {
    window.open(`${welcomeUrl}/welcome`, "_blank", "width=800,height=800,left=100,top=100,resizable=yes,scrollbars=yes");
  }

  return (
    <>
      <Stack width="100%" spacing={2}>
        <Stack spacing={4} pt={0}>
          {(process.env.REACT_APP_AUTH === "BOTH" || process.env.REACT_APP_AUTH === "SSO") && (
            <BaseBTN
              fullWidth
              color="primary"
              variant={process.env.REACT_APP_AUTH === "BOTH" ? "outlined" : "contained"}
              onClick={loginGoverment}
            >
              <Stack gap={1} flexDirection={"row"}>
                <SSOIcon color={theme.palette.primary.main} />
                ورود از طریق دولت من
              </Stack>
            </BaseBTN>
          )}

          {(process.env.REACT_APP_AUTH === "BOTH" || process.env.REACT_APP_AUTH === "SSO") && (
            <Stack direction="row" alignItems="center" justifyContent="center" spacing={0.5}>
              <Typography variant="subtitle2">{AuthFormData.dontHaveUsername}</Typography>
              <Link to="#" onClick={handleOpenSSORegister}>
                <Typography color="primary.main" variant="subtitle2">
                  {AuthFormData.SSOregister}
                </Typography>
              </Link>
            </Stack>
          )}
        </Stack>
        {process.env.REACT_APP_AUTH === "BOTH" && (
          <Stack flexDirection={"row"} gap={5} justifyContent={"center"} pt={0}>
            <Stack height={"4px"} bgcolor={"grey.g6"} width={"50%"} sx={{ borderRadius: 5 }} mt={1} />
            <Typography color={"grey.g3"}>یا</Typography>
            <Stack height={"4px"} bgcolor={"grey.g6"} width={"50%"} sx={{ borderRadius: 5 }} mt={1} />
          </Stack>
        )}
        {(process.env.REACT_APP_AUTH === "MANUAL" || process.env.REACT_APP_AUTH === "BOTH") && (
          <Formik onSubmit={handleSubmit} initialValues={formData} validationSchema={loginValidation}>
            {({ handleChange, values, isValid }) => (
              <Form>
                <Stack spacing={4}>
                  <Stack spacing={1}>
                    <InputLabel htmlFor="username">
                      {AuthFormData.username}
                      <Typography component="span" color="error.main">
                        *
                      </Typography>
                    </InputLabel>
                    <Field
                      as={TextField}
                      variant="outlined"
                      fullWidth
                      id="username"
                      name="username"
                      value={values.username}
                      onChange={(e) => {
                        setFormData({ ...formData, usename: e.target.value });
                        handleChange(e);
                      }}
                      placeholder="نام کاربری خود را وارد کنید."
                      helperText={<ErrorMessage name="username" />}
                    />
                    <PasswordInput
                      formData={formData}
                      title={AuthFormData.password}
                      id="password"
                      handleChange={handleChange}
                      setFormData={setFormData}
                      values={values.password}
                      onChange={(e) => {
                        setFormData({ ...formData, password: e.target.value });
                        handleChange(e);
                      }}
                      placeholder="رمز عبور خود را وارد کنید."
                    />
                  </Stack>
                  <BaseBTN color="primary" variant="contained" fullWidth type="submit" disabled={!isValid}>
                    {AuthFormData.signInBtn}
                  </BaseBTN>
                </Stack>
              </Form>
            )}
          </Formik>
        )}
        {(process.env.REACT_APP_AUTH === "BOTH" || process.env.REACT_APP_AUTH === "MANUAL") && (
          <Stack direction="row" alignItems="center" justifyContent="center" spacing={0.5}>
            <Typography variant="subtitle2">{AuthFormData.dontHaveUsername}</Typography>
            <Link to="#" onClick={handleOpenRegister}>
              <Typography color="primary.main" variant="subtitle2">
                {AuthFormData.register}
              </Typography>
            </Link>
          </Stack>
        )}
        {(process.env.REACT_APP_AUTH === "MANUAL" || process.env.REACT_APP_AUTH === "BOTH") && (
          <Stack direction="row" alignItems="center" justifyContent="center" spacing={0.5}>
            <Typography variant="subtitle2">{AuthFormData.forgetPassDesc}</Typography>
            <Link to="/forget-password">
              <Typography color="primary.main" variant="subtitle2">
                {AuthFormData.retrivePass}
              </Typography>
            </Link>
          </Stack>
        )}

        <Stack direction="row" alignItems="center" justifyContent="center" spacing={0.5}>
          <Link onClick={popUpTracking}>
            <Typography color="primary.main" variant="subtitle2">
              رهگیری در زنجیره
            </Typography>
          </Link>
        </Stack>
      </Stack>
      <ConfirmationDialog openRegister={open} onCloseRegister={handleCloseRegister} />
      <LoadingScreen open={loadingSecureLogin} title="لطفا منتظر بمانید ..." />
    </>
  );
};
export default LoginForm;
